<template>
  <div class="booking-divider booking-divider-right booking-payment-widget">
    <div class="booking-content">
      <div id="sumup-card"></div>
    </div>
    <div v-if="loadedWidget" class="fixed-buttons d-flex flex-column">
      <template v-if="storeCardOnly">
        <button class="btn btn-tertiary w-100" @click="submitPayment" :disabled="isLoading">
          Save
          <span v-if="isLoading" class="inline-loader"></span>
        </button>
      </template>
      <template v-else>
        <button class="btn btn-primary w-100" @click="submitPayment" :disabled="isLoading">
          Pay {{ currencySymbol }}{{ amount.toFixed(2).toString() }}
          <span v-if="isLoading" class="inline-loader"></span>
        </button>
        <button class="btn btn-outline-secondary w-100 mt-2" @click="$emit('completed')" :disabled="isLoading">Cancel</button>
      </template>
    </div>
  </div>
</template>

<script>
import { CountryCacheMixin } from '@/mixins/Booking/CountryCacheMixin'

/* eslint-disable */
export default {
  name: 'SumUpWidget',
  mixins: [CountryCacheMixin],
  props: {
    payment: Object
  },
  data() {
    return {
      loadedWidget: false,
      sumUpCardInstance: null,
      isLoading: false,
    }
  },
  computed: {
    providerReference() {
      return !!this.payment ? this.payment.providerReference : ''
    },
    amount() {
      return !!this.payment ? this.payment.amount : 0;
    },
    currency() {
      return !!this.payment ? this.payment.currency : ''
    },
    currencySymbol() {
      const { currency, currencySymbol } = this.country || {};
      return currency === this.currency ? currencySymbol : `${this.currency} `;
    },
    paymentType(){
      return !!this.payment ? this.payment.paymentType : null;
    },
    storeCardOnly(){
      return this.paymentType.id == 1;
    }
  },
  methods: {
    submitPayment() {
      if (this.sumUpCardInstance) {
        this.isLoading = true;
        this.sumUpCardInstance.submit();
      }
    }
  },
  mounted() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://gateway.sumup.com/gateway/ecom/card/v2/sdk.js'
    script.onload = () => {
      this.sumUpCardInstance = SumUpCard.mount({
        id: 'sumup-card',
        checkoutId: this.providerReference,
        showFooter: false,
        showSubmitButton: false,
        onResponse: (type, body) => {
          if (type === 'success') {
            this.$emit('completed')
            this.isLoading = false;
          } else if (type === 'error') {
            this.$emit('completed')
            this.isLoading = false;
          } else if (type === 'invalid') {
            this.isLoading = false;
          } else if (type === 'auth-screen') {
            this.loadedWidget = false;
          }
        },
        onLoad: () => {
          this.loadedWidget = true;
        }
      });
    }
    document.head.appendChild(script);
  }
}
</script>
